import { DirectionalHint, IComboBox, IComboBoxOption, TooltipHost } from '@fluentui/react';
import { AlertColor } from "@mui/material/Alert";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Temporality, TemporalityVO, WorkSpaceUserName } from "../../../model/ItemModel";
import {
    SetTemporality
} from "../../../services/Item/ItemServicesCRUD";
import {
    GetEnumTemporality,
    GetItemWithTemporality,
    GetOneItem,
} from "../../../services/Item/ItemServicesGet";
import info from "../../../assets/icons/info.svg"
import infoHover from "../../../assets/icons/infoHover.svg"
import { Box, CircularProgress, Grid, Select } from '@mui/material';
import { WatchLater } from '@mui/icons-material';
import { KeyDriveBodyMax } from '../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax';
import { KeyDriveBodyMin } from '../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin';
import KeydriveSnackbar from '../../../components/KeydriveComponents/Snackbar/KeydriveSnackbar';
import WorkSpaceItemListFileComponentImage from '../WorkSpaceItemListFileComponentImage';
import KeyDriveDatePicker from '../../../components/KeydriveComponents/Textfield/KeydriveDatePicker';
import { CheckboxOption, KeydriveCheckboxGroup } from '../../../components/KeydriveComponents/Textfield/KeydriveCheckboxGroup';
import KeyDriveCounter from '../../../components/KeydriveComponents/Textfield/KeydriveCounter';
import { MenuItem } from '@mui/material';
import { forEach } from 'lodash';
import { getFutureDateString } from '../../../utils/setDate';
import { KeyDrivePrimaryButton } from '../../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton';


export interface TemporalityConfig {
    itemId: string;
    setTemporalityInternal: (newTemporality: Temporality | undefined, expired: boolean, archiving: boolean, draft: boolean) => void;
}

export interface TemporalityDocumentParams {
    temporalityConfig: TemporalityConfig;
    saveOkMetod: () => void;
    resetOkMetod: () => void;
    resetPanel: () => void;
}

export interface ItemporalityItemInfo {
    name: string;
    extension: string;
    id: string;
}


const TemporalityDocument = (props: TemporalityDocumentParams) => {
    const { t, i18n } = useTranslation();
    const [temporality, setTemporality] = useState<Date | undefined>(new Date());
    const [optionsTemporality, setOptionsTemporality] = useState<IComboBoxOption[]>([]);
    const [keySelectTemporality, setKeySelectTemporality] = useState<number | undefined>(undefined);
    const [temporalityItemInfo, setTemporalityItemInfo] = useState<ItemporalityItemInfo>();
    const [messageErrorString, setMessageErrorString] = useState<string | undefined>(undefined);
    const [variant, setVariant] = useState<AlertColor>('error');
    const [loading, setLoading] = useState<boolean>(false);
    const [selected, setSelected] = useState<number[]>([]);
    const [quantity, setQuantity] = useState<number>(1);
    const [disableCustomDays, setDisableCustomDays] = useState<boolean>(false);

    const temporalityCheckboxOptions: CheckboxOption[] = [
        { label: t("Temporality.DaysAdvance30"), value: 0 },
        { label: t("Temporality.DaysAdvance7"), value: 1 },
        { label: t("Temporality.DaysAdvance1"), value: 2 },
        { label: t("Temporality.DealineDay"), value: 3 },
        { label: t("Temporality.Custom"), value: 4 },
    ];

    useEffect(() => {
        if (selected.includes(4, 0)) {
            setDisableCustomDays(false);
        } else {
            setDisableCustomDays(true);    
        }
    }, [selected]);

    useEffect(() => {
        fetchItem();
    }, [props.temporalityConfig.itemId]);

    function setDealineDates(): string[] {
        let dates: string[] = [];

        if (selected.length <= 0) return dates;

        selected.forEach(value => {
            dates.push(getDateBySelectedValue(value));
        });

        return dates;
    }

    function getDateBySelectedValue(value: number): string {

        if (temporality == undefined) return "";

        switch(value) {
            case 0:
                return getFutureDateString(temporality, 30);
            case 1:
                return getFutureDateString(temporality, 7);
            case 2:
                return getFutureDateString(temporality, 1);
            case 3:
                return temporality ? temporality.toDateString() : '';
            case 4:
                return getFutureDateString(temporality, quantity);
            default:
                return "";
        }
    }

    function mapFetchItemToItemInfo(fetchedItem: WorkSpaceUserName): ItemporalityItemInfo {
        return {
            name: fetchedItem.name!,
            extension: fetchedItem.extension!,
            id: fetchedItem.idMongo!
        }
    }

    async function fetchItem() {
        try {
            setLoading(true);
            if (props.temporalityConfig.itemId == undefined) return;

            const fetchedItem = await GetOneItem(props.temporalityConfig.itemId);

            setTemporalityItemInfo(mapFetchItemToItemInfo(fetchedItem));

        } catch (err: any) {

            setMessageErrorString(err.response.data || t("UnableToReturnItem.message"));
            setVariant("error");

        } finally {
        
            setLoading(false);

        }
    }

    useEffect(() => {
        let optionInter: IComboBoxOption[] = [];

        GetEnumTemporality()
            .then((enumReturn) => {
                enumReturn.map((data) => {
                    optionInter.push({
                        key: data.index,
                        text: data.name,
                    });

                    setOptionsTemporality(optionInter)
                })
            })
    }, []);

    useEffect(() => {
        GetItemWithTemporality(props.temporalityConfig.itemId)
            .then((returnJson) => {
                if (returnJson.itemTemporality != undefined) {
                    setKeySelectTemporality(returnJson.itemTemporality.enumTemporality)
                    if (returnJson.itemTemporality.itemTemporality != undefined)
                        setTemporality(new Date(returnJson.itemTemporality.itemTemporality))
                    if (returnJson.itemTemporality.deadlineIndexes != undefined) {
                        setSelected([...selected, ...returnJson.itemTemporality.deadlineIndexes]);
                    } 
                    if (returnJson.itemTemporality?.customDayQuantity != undefined) {
                        setQuantity(returnJson.itemTemporality?.customDayQuantity);
                    }
                }
            })
            .catch((error) => {
                if (error.response && error.response.data && typeof error.response.data === 'string') {
                    setMessageErrorString(error.response.data);
                }
                else {
                    setMessageErrorString(t("UnableToReturnItemTemporality.message"));
                }
            })
            .finally(() => {
                setLoading(false);
            })
    }, [optionsTemporality])

    const onFormatDate = (date?: Date): string => {
        if (!date) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear());
        return i18n.language === 'pt-BR' ? `${day}/${month}/${year}` : `${month}/${day}/${year}`;
    };
    
    const save = () => {

        if (keySelectTemporality == undefined) {
            setMessageErrorString(t("EmptyTemporalityField.message"));
            return
        }

        const deadlineDates = setDealineDates();

        var validateDocumentVO: TemporalityVO = {
            itemId: props.temporalityConfig.itemId,
            itemTemporality: temporality?.toDateString(),
            enumTemporality: keySelectTemporality,
            deadlineDates: deadlineDates,
            deadlineIndexes: selected,
            customDayQuantity: quantity
        }

        setLoading(true);
        SetTemporality(validateDocumentVO)
            .then(() => {
                    props.temporalityConfig.setTemporalityInternal({
                        itemTemporality: temporality?.toDateString(),
                        enumTemporality: keySelectTemporality,
                        deadlineDates: deadlineDates
                    },
                    temporality? (keySelectTemporality == 2 && new Date() >= temporality! ? true : false) : false,
                    temporality? (keySelectTemporality == 0 && new Date() >= temporality! ? true : false) : false,
                    temporality? (keySelectTemporality == 1 && new Date() >= temporality! ? true : false) : false       
                )
                props.saveOkMetod()
            })
            .catch((error) => {
                if (error.response && error.response.data && typeof error.response.data === 'string') {
                    setMessageErrorString(error.response.data);
                }
                else {
                    setMessageErrorString(t("ErroAoSalvar.message"));
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <Grid container display="flex" flexDirection="column" spacing={2}>
            <Grid item xs={12}>
                <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    mb="8px"
                >
                    <WatchLater />
                    <KeyDriveBodyMax 
                        color='#2d2d2d'
                        text={t("Temporality.message")}
                        needBold
                        needEllipses={false}
                    />
                </Box>
                <KeyDriveBodyMin 
                    text={t("Temporality.Content")}
                    needBold={false}
                    needEllipses={false}
                    color="#969696"
                />
            </Grid>

            { loading ? (
                <CircularProgress />
            ) : (
                <>
                    <Grid item xs={12}>

                        <Box
                            display="flex"
                            alignItems="center"
                            gap={1}
                            border="1px solid #EAEAEA"
                            borderRadius="4px"
                            padding="8px"
                            marginBottom="12px"
                        >
                            <WorkSpaceItemListFileComponentImage 
                                extension={temporalityItemInfo?.extension}
                                isFolder={false}
                                widthIcon='14'
                            />

                            <KeyDriveBodyMin 
                                text={temporalityItemInfo?.name || "N/A"}
                                needBold={false}
                                needEllipses={true}
                                color="#2B2B2B"
                            />
                        </Box>
                        <KeyDriveBodyMax 
                            text={t("Temporality.Deadline")}
                            needBold
                            needEllipses={false}
                            color="#2b2b2b"
                        />
                        <KeyDriveDatePicker 
                            minDate={new Date("1970-01-01")}
                            onChange={(date: any) => setTemporality(date || undefined)}
                            value={temporality!}
                            maxDate={new Date("2100-12-31")}
                        />

                    </Grid>
                    <Grid item xs={12} display="flex" flexDirection="column" gap={2}>

                        <KeyDriveBodyMax 
                            needBold
                            color='#2b2b2b'
                            needEllipses={false}
                            text={t("TemporalityComboBox.ExplanatoryText")}
                        />

                        <Select
                            variant='standard'
                            fullWidth
                            value={keySelectTemporality}
                            onChange={e => {
                                setKeySelectTemporality(e.target.value as number);
                            }}
                            MenuProps={{
                                disablePortal: true,
                            }}
                        >
                            { optionsTemporality.map((option: any) => (
                                <MenuItem key={option.key} value={option.key}>{option.text}</MenuItem>
                            )) }
                        </Select>

                        <Box>
                            <KeyDriveBodyMax 
                                needBold
                                color='#2b2b2b'
                                needEllipses={false}
                                text={t("Temporality.NotifyDeadline")}
                            />

                            <KeyDriveBodyMin 
                                needBold={false}
                                color='#818181'
                                needEllipses={false}
                                text={t("Temporality.NotifyDeadlineContent")}
                            />
                        </Box>

                        <KeydriveCheckboxGroup 
                            options={temporalityCheckboxOptions}
                            onChange={setSelected}
                            selectedValues={selected}
                        />

                        <KeyDriveBodyMin 
                            needBold={false}
                            text={t("Temporality.Quantity")}
                            color="#969696"
                            needEllipses={false}
                            fontStyle='italic'
                        />

                        <KeyDriveCounter
                            value={quantity}
                            onChange={setQuantity}
                            min={1}
                            max={99}
                            disabled={disableCustomDays}
                        />

                        <KeyDrivePrimaryButton 
                            TextComponent={KeyDriveBodyMin}
                            TextComponentProps={{
                                color: "white",
                                text: t("Temporality.Apply"),
                                needBold: false,
                                needEllipses: false,
                            }}
                            onClick={save}
                            needFullWidth
                        />

                    </Grid>
                </>
            ) }


            <KeydriveSnackbar 
                open={messageErrorString != undefined}
                message={messageErrorString}
                onClose={() => setMessageErrorString(undefined)}
                variant={variant}
            />
        </Grid>
    )
}

export default TemporalityDocument;